import { useIsMutating } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import { PERIODIC_REVIEW_CONFIRMATION_MUTATION_KEY, useProfilePeriodicReviewConfirmationMutation } from '@/hooks/queries/use-profile-periodic-review';
import ErrorPage from '@/pages/error';
import LoadingPage from '@/pages/loading';

// A confirmation that failed part way has moved the review on, so confirming again finishes what's left
const PeriodicReviewFinish = () => {
  const { isIdle, mutate } = useProfilePeriodicReviewConfirmationMutation();
  const isPending = useIsMutating({ mutationKey: PERIODIC_REVIEW_CONFIRMATION_MUTATION_KEY }) > 0;
  const hasTriggeredConfirmation = useRef(false);

  useEffect(() => {
    if (!hasTriggeredConfirmation.current) {
      hasTriggeredConfirmation.current = true;

      mutate();
    }
  }, [mutate]);

  // The guard moves on from a confirmation that finishes, so still being here once it settles means it failed
  if (!isIdle && !isPending) return <ErrorPage />;

  return <LoadingPage />;
};
PeriodicReviewFinish.displayName = 'PeriodicReviewFinish';

export default PeriodicReviewFinish;
